import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Input  } from '@angular/core';
import { DataService } from '../../../services/data/data.service';
import { Subscription } from '../../../../../node_modules/rxjs';
import { BoxQuotaData } from '../../../model/box.quote.data';

@Component({
    selector: 'cu-download-link-cell-ordertype-renderer',
    template: `<span>{{Qty}}</span>`
  })

  
  export class orderQtyCellRenderer {
      params:any;
      constructor( ) { 

      }
      
     

  private _Qty: string = "";
  public get Qty (): string {
   // string

    if( this._Qty.substr(-3,3) == "000")
    {
      let length = this._Qty.length;
      return this._Qty.substring(0, length - 3) + "k";
    }

    return this._Qty;
  }


  public set Qty ( value: string ) {
    this._Qty = value;
  }


      agInit(params:any): void { 
          this.params = params;
           this.Qty = ( this.params.data.Qty!=null )?String(this.params.data.Qty):""; 
     }
    


     refresh(params: any): void {
      this.params = params;
      this.Qty = ( this.params.data.Qty!=null )?String(this.params.data.Qty):""; 
      }

  }
  
  export type CellAction = (params:any) => void;